import CardDesignerBackgroundGroupBadge from './CardDesignerBackgroundGroupBadge';

export default CardDesignerBackgroundGroupBadge;
